import styled from 'styled-components';
import Button from '../../BuildingBlocks/Button';
import { colors, mixins } from '../../css';

const { colorGreyRgba } = colors;
const { pxToRem } = mixins;

const button = styled(Button)`
  background: ${colorGreyRgba(0.8)};
  display: flex;
  align-items: center;
  &:hover {
    background: ${colorGreyRgba(0.6)};
  }
  .label {
    margin-right: ${pxToRem(9)};
  }
`;

export default { Button: button };
